import * as React from 'react';

import Musthead from '@app/components/UI/MustHead/Musthead';

import RichText from '@app/components/UI/RichText/RichText';

import {CustomMenuItem} from '@app/objects/CustomMenuItem';
import CardLinks from '@app/components/UI/CardLinks/CardLinks';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';
import listenerForBrowser from '@app/components/Pages/listenerForBrowser';

import {griefText, griefTitle,
	helpingAnimalsText,
	helpingAnimalsTitle,
	helpingBooksList, helpingBooksTitle, helpingList, lossBooksList, lossBooksTitle, specificInfoList, specificInfoTitle} from './PetLossChildrenGriefContent';

const PetLossChildrenGrief = () => {
	const [navCollapse, setNavCollapse] = React.useState(false);
	const [isMobile, setIsMobile] = React.useState(false);
	const [breadcrumbs, setBreadcrumbs] = React.useState<CustomMenuItem[]>();

	React.useEffect(() => {
		const mql = window.matchMedia('screen and (max-width: 768px)');

		const listenerFunc = () => {
			if (mql.matches) {
				setNavCollapse(true);
			} else {
				setNavCollapse(false);
			}

		};
		listenerFunc();
		listenerForBrowser(mql, listenerFunc);
	}, []);

	React.useEffect(() => {
		const mql = window.matchMedia('screen and (max-width: 600px)');

		const listenerFunc = () => {
			if (mql.matches) {
				setIsMobile(true);
			} else {
				setIsMobile(false);
			}
		};
		listenerFunc();
		listenerForBrowser(mql, listenerFunc);
	}, []);

	React.useEffect(() => {
		const bc: CustomMenuItem[] = [
			{
				path: '/pet-loss-support-resources',
				name: 'Pet Loss Support Resources',
			},
			{
				path: '',
				name: 'Children and Pet Grief Resources',
			},
		];

		setBreadcrumbs(bc);

	}, []);

	return (
		<div className="pet-loss-grief">
			<Musthead
				title="Grief Resources for Children and Pets"
				imageSrc={require('@app/content/petLossChildrenGriefHeader.jpg')}
				breadcrumbs={breadcrumbs}
				backPath={{
					path: '/pet-loss-support-resources',
					name: 'Back to pet loss support resources',
				}}
				imageAlt="Children loss of pet"
			/>

			<RichText
				title={griefTitle}
				text={griefText}
			/>
			<CardLinks list={helpingList}/>

			<RichText text={helpingBooksTitle}/>
			<CardLinks list={helpingBooksList}/>

			<RichText
				text={lossBooksTitle}
			/>
			<CardLinks list={lossBooksList}/>

			<RichText
				title={helpingAnimalsTitle}
				text={helpingAnimalsText}
			/>

			<RichText text={specificInfoTitle}/>
			<CardLinks list={specificInfoList}/>
		</div>
	);
};

export default withSeo(PetLossChildrenGrief, state => state.childrenGriefPage, 'childrenGriefPage', 'pet-loss-support-resources/children-and-pet-grief-resources');